export const env = {
  baseUrl: 'https://admin.whoisinbcn.com',
};
